/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useEffect, useRef, useState} from "react";
import {
  useCheckMobileView,
  useOnClickOutside
} from "helpers";

import Calculator from "./Calculator";

const productResultMap = {
  multipleProducts: {one: "15,000", ten: "40,000", fifty: "1L", hundred: "2L", twoHundred: "3L"},
  preIpo: {one: "5,000", ten: "12,500", fifty: "30,000", hundred: "50,000", twoHundred: "80,0000"},
  healthInsurance: {one: "5,000", ten: "18,000", fifty: "40,000", hundred: "80,000", twoHundred: "1.25L"},
  lifeInsurance: {one: "15,000", ten: "30,000", fifty: "75,000", hundred: "1.5L", twoHundred: "2.5L"},
  mutualFunds: {one: "6,000", ten: "18,000", fifty: "40,000", hundred: "75,000", twoHundred: "1.25L"}
};

const clientNumbersMap = {
  one: "1-10 clients",
  ten: "10-50 clients",
  fifty: "50-100 clients",
  hundred: "100-200 clients",
  twoHundred: "200+ clients"
};

const productsMap = {
  multipleProducts: "Multiple Products",
  healthInsurance: "Only Health Insurance",
  lifeInsurance: "Only Life Insurance",
  mutualFunds: "Only Mutual Funds",
  preIpo: "Only Pre-IPO"
};

const professionOptions = [
  "Wealth Partner",
  "Banker",
  "Insurance Advisor",
  "Stock Broker",
  "Accountant",
  "Finance Enthusiast"
];

// TODO: Cleanup this component

const CalculatorContainer = () => {
  const [showProfessionDropdown, setShowProfessionDropdown] = useState(false);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [showProductDropdown, setShowProductDropdown] = useState(false);

  const [selectedProfession, setSelectedProfession] = useState(professionOptions[0]);
  const [selectedClientsValue, setSelectedClientsValue] = useState("hundred");
  const [selectedProduct, setSelectedProduct] = useState("multipleProducts");

  const [result, setResult] = useState("");

  const professionRef = useRef();
  const clientsRef = useRef();
  const productsRef = useRef();

  const isMobileView = useCheckMobileView();

  useOnClickOutside(professionRef, () => setShowProfessionDropdown(false));
  useOnClickOutside(clientsRef, () => setShowClientDropdown(false));
  useOnClickOutside(productsRef, () => setShowProductDropdown(false));

  useEffect(() => {
    const resultant = productResultMap[selectedProduct];
    setResult(resultant[selectedClientsValue]);
  }, [selectedProduct, selectedClientsValue]);

  useEffect(() => {
    addAnimation(`selected-profession-${selectedProfession}`);
  }, [selectedProfession]);

  useEffect(() => {
    addAnimation(`selected-product-${selectedProduct}`);
    if (showClientDropdown || showProfessionDropdown) {
      document.getElementById(`selected-product-${selectedProduct}`).style.transform = "none";
      document.getElementById(`selected-product-${selectedProduct}`).style.zIndex = 1;
    } else {
      document.getElementById(`selected-product-${selectedProduct}`).style.transform = "translateY(0)";
      document.getElementById(`selected-product-${selectedProduct}`).style.zIndex = 1;
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (isMobileView) {
      document.getElementById(`selected-clients-value-${selectedClientsValue}`).style.transform = "none";
      document.getElementById(`selected-clients-value-${selectedClientsValue}`).style.zIndex = 1;
      if (showClientDropdown) {
        document.getElementById(`selected-clients-value-${selectedClientsValue}`).style.transform = "translateY(0)";
        document.getElementById(`selected-clients-value-${selectedClientsValue}`).style.zIndex = 2;
      }
    }
  }, [showClientDropdown]);

  useEffect(() => {
    addAnimation(`selected-clients-value-${selectedClientsValue}`);
  }, [selectedClientsValue]);


  useEffect(() => {
    const contentElement = document.getElementById("result");

    if (contentElement.classList.contains("in-view")) {
      contentElement.classList.remove("in-view");
      contentElement.classList.add("fade-in");
    }
    setTimeout(() => {
      contentElement.classList.add("in-view");
    }, 100);
  }, [result]);

  const addAnimation = (id) => {
    const contentElement = document.getElementById(id);

    if (contentElement && contentElement.classList.contains("drop-item-in-view")) {
      contentElement.classList.remove("drop-item-in-view");
      contentElement.classList.add("drop-item-fade-in");
    }
    setTimeout(() => {
      if (contentElement) {
        contentElement.classList.add("drop-item-in-view");
      }
    }, 100);
  };


  return (
    <Calculator
      clientNumbersMap={clientNumbersMap}
      clientsRef={clientsRef}
      productResultMap={productResultMap}
      productsMap={productsMap}
      productsRef={productsRef}
      professionOptions={professionOptions}
      professionRef={professionRef}
      result={result}
      selectedClientsValue={selectedClientsValue}
      selectedProduct={selectedProduct}
      selectedProfession={selectedProfession}
      setResult={setResult}
      setSelectedClientsValue={setSelectedClientsValue}
      setSelectedProduct={setSelectedProduct}
      setSelectedProfession={setSelectedProfession}
      setShowClientDropdown={setShowClientDropdown}
      setShowProductDropdown={setShowProductDropdown}
      setShowProfessionDropdown={setShowProfessionDropdown}
      showClientDropdown={showClientDropdown}
      showProductDropdown={showProductDropdown}
      showProfessionDropdown={showProfessionDropdown}
    />
  );
};

export default CalculatorContainer;


